export const locale = {
    lang: 'es',
    tree_ngx: {
        NO_MATCH_SEARCH: 'No hay coincidencias en la búsqueda'
    }
};
